import React, {useRef, useState} from 'react';

import TableCell from '@material-ui/core/TableCell';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutline";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import IconButton from "@material-ui/core/IconButton";
import AttachIcon from '@material-ui/icons/AttachFile'
import Refresh from '@material-ui/icons/Refresh'
import SearchIcon from '@material-ui/icons/Search'

import DescartarCartaoDialog from "@pages/TratamentoNomes/DescartarCartaoDialog"
import TransferirCartaoDialog from "@pages/Escola/Cartoes/componentes/TransferirCartaoDialog"

import DialogConfirm from "@base/Dialog/DialogConfirm";
import Dialog from '@base/Dialog'
import File from "@base/Inputs/File"
import TextField from "@base/Inputs/Text"
import {ButtonSave} from "@base/Button/ButtonForm"
import Loading from "@base/Loading";
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';

import EscolaService from "@services/EscolaService";

const ActionCellBody = ({action, id, object}) => {

  if (!action.func) {
    return null
  }

  return (
    <TableCell align="right">
      <Tooltip title={action.name(id, object)} TransitionComponent={Zoom}>
        <span style={action.disabled(id, object) ? {cursor: 'not-allowed'} : {}}>
          <IconButton
            size="small"
            component="div"
            color={action.color ? (typeof action.color === "function" ? action.color(id, object) : action.color) : "primary"}
            aria-label={action.name(id, object)}
            onClick={() => action.func(id, object)}
            disabled={action.disabled(id, object)}
            style={action.disabled(id, object) ? {pointerEvents: "none"} : {}}
          >
            {typeof action.icon === "function" ? action.icon(id, object) : action.icon}
          </IconButton>
        </span>
      </Tooltip>
    </TableCell>
  )
}


export const BuscarCartoesClonados = ({object, processo,}) => {
  const toastRef = useRef(null);

  if (processo !== undefined) {
    const filters = [];
    filters.push({field: 'nome', value: object.nomeAluno});
    filters.push({field: 'inep', value: object.original.codigoInep});
    EscolaService.buscarCartoes(processo, filters).then((resultado) => {
      return (resultado.data.content)
    }).catch(erro => {
      return (toastRef.current.show("error", "Não foi possível buscar cartões duplicados."))
    });
  }
};

// const restaurarCartao = (cartao, setLoading) => {
//   EscolaService.restaurarCartao(processo, cartao.id).then(() => {
//     setOpenDialogRestaurarCartao(false);
//     setLoading(false);
//     setHoraUltimoRefresh(new Date())
//
//   });
// }




export const VisualizarCartao = props => {
  const [openModalVisualizarArquivo, setOpenModalVisualizarArquivo] = useState(false);
  const [blob, setBlob] = useState();
  const [loading, setLoading] = useState(false);
  
  return (
    <>
      <Tooltip title="Visualizar Cartão" TransitionComponent={Zoom}>
        <IconButton
          size="small"
          component="div"
          color="primary"
          aria-label="Visualizar Cartão"
          onClick={() => {
            setOpenModalVisualizarArquivo(true);
            setLoading(true);

            EscolaService.downloadArquivoCartao("-", undefined, props.cartao.id).then(resultado => {
              setBlob(resultado.data);
              setLoading(false);
            })}}
        >
          <SearchIcon/>
        </IconButton>
      </Tooltip>

      {openModalVisualizarArquivo &&
        <Dialog
          maxWidth={"lg"}
          fullWidth={true}
          closeDialog={() => setOpenModalVisualizarArquivo(false)}
          openDialog={openModalVisualizarArquivo}
          title={`Cartão ${props.cartao.codigo}`}
          actions={[]}
        >
          { loading ?
            <Loading />
          :
            <VisualizadorDeArquivo blob={blob} />
          }
        </Dialog>
      }
    </>
  )
}


export const DescartarCartao = props => {
  const [openDialogDescartarCartao, setOpenDialogDescartarCartao] = useState(false);
  const [cartaoSelecionado, setCartaoSelecionado] = useState("");
  const [openDialogRestaurarCartao, setOpenDialogRestaurarCartao] = useState(false);

  const restaurarCartao = (cartao, setLoading) => {
    EscolaService.restaurarCartao(props.processo, cartao.id).then(() => {
      setOpenDialogRestaurarCartao(false);
      setLoading(false);
      props.aoDescartar();
    });
  }

  const title = props.cartao.status && props.cartao.status === "DESCARTADO" && !props.cartao.substituido ? "Restaurar Cartão" : "Descartar Cartão";
  const icon = props.cartao.status && props.cartao.status === "DESCARTADO" && !props.cartao.substituido ? <RestoreFromTrashIcon/> : <DeleteOutlinedIcon/>;

  return (
    <>
      <Tooltip title={title} TransitionComponent={Zoom}>
        <IconButton
          size="small"
          component="div"
          color={props.cartao.status && props.cartao.status === "DESCARTADO" ? "primary" : "secondary"}
          aria-label={title}
          disabled={props.cartao.substituido}
          onClick={() => {
            const crt = props.cartoes.find(c => c.id === props.cartao.id);
            setCartaoSelecionado(crt);

            if (crt.status && crt.status === "DESCARTADO")
              setOpenDialogRestaurarCartao(true);
            else
              setOpenDialogDescartarCartao(true);
          }}
        >
          {icon}
        </IconButton>
      </Tooltip>

      {openDialogRestaurarCartao &&
        <DialogConfirm
          maxWidth={"sm"}
          id={{id: cartaoSelecionado.id}}
          text={"Deseja realmente restaurar este cartão?"}
          close={() => {
            setOpenDialogRestaurarCartao(false)
            if (props.aoFechar) {
              props.aoFechar();
            }
          }}
          open={openDialogRestaurarCartao}
          title={"Importante"}
          handleConfirm={restaurarCartao}

        />
      }

      {openDialogDescartarCartao &&
        <DescartarCartaoDialog
          aoConfirmar={() => {setOpenDialogDescartarCartao(false)
            if (props.aoDescartar)
              props.aoDescartar();
          }}
          aoFechar={() => setOpenDialogDescartarCartao(false)}
          aberto={openDialogDescartarCartao}
          processo={props.processo}
          motivosDescarteDisponiveis={props.motivosDescarteDisponiveis ? props.motivosDescarteDisponiveis : []}
          id={cartaoSelecionado.id}
          codigo={cartaoSelecionado.codigo}
        />}
    </>
  )
}

export const ReetiquetarCartao = props => {
  const [listaDeCartoesMarcados, setListaDeCartoesMarcados] = useState({});
  const [openDialogTransferirCartoes, setOpenDialogTransferirCartoes] = useState(false);

  const handleTransferirCartao = (obj) => {
    setListaDeCartoesMarcados({
      codigoInep: obj.codigoInep,
      escolaNome: obj.escola,
      cartoes: [{id: obj.id, nivel: obj.nivel, codigo: obj.codigo}]
    });
    setOpenDialogTransferirCartoes(true);
  }

  return (
    <>
      <Tooltip title="Transferir (Reetiquetar)" TransitionComponent={Zoom}>
        <IconButton
          size="small"
          component="div"
          color={"primary"}
          aria-label="Transferir (Reetiquetar)"
          onClick={() => handleTransferirCartao(props.cartao)}
        >
          <SwapHorizIcon/>
        </IconButton>
      </Tooltip>

      {openDialogTransferirCartoes &&
        <TransferirCartaoDialog
          processo={props.processo}
          listaDeCartoes={listaDeCartoesMarcados}
          aberto={openDialogTransferirCartoes}
          aoFechar={() => {
            setOpenDialogTransferirCartoes(false);
            if (props.aoFechar) {
              props.aoFechar();
            }
          }}
          aoSalvar={() => {
            setOpenDialogTransferirCartoes(false);

            if (props.aoTransferir)
              props.aoTransferir();
          }}
        />
      }
    </>
  )

}

export const AnexarDigitalizacao = props => {
  const [cartaoSelecionado, setCartaoSelecionado] = useState("");
  const [openDialogArquivo, setOpenDialogArquivo] = useState(false);

  const abrirModalUploadArquivo = (id) => {
    setCartaoSelecionado(props.cartoes.find(c => c.id === id));
    setOpenDialogArquivo(true);
  }
  return (
    <>
      <ActionCellBody id={props.cartao.id}
                      action={{
                        name: () => "Anexar Digitalização",
                        func: abrirModalUploadArquivo,
                        icon: <AttachIcon/>,
                        disabled: (id, cartao) => cartao.status === "DESCARTADO",
                      }}
                      object={props.cartao}/>

      {openDialogArquivo &&
        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          closeDialog={() => setOpenDialogArquivo(false)}
          openDialog={openDialogArquivo}
          title={"Enviar Cartão Resposta"}
          actions={[]}
        >
          <File handleUpload={(arquivo) => {
            const config = {headers: {'content-type': 'multipart/form-data'}};

            const file = new FormData();
            file.append('nmArquivo', arquivo.name);
            file.append('tipoArquivo', arquivo.type);
            file.append('descricao', arquivo.description);
            file.append('arquivo', arquivo);

            EscolaService.uploadArquivoCartao(
              props.processo,
              cartaoSelecionado.escola,
              cartaoSelecionado.id,
              file,
              config).then(resultado => {
              setOpenDialogArquivo(false);
            }).catch(erro => {
              setOpenDialogArquivo(false);
              props.aoOcorrerErro();
            });
          }}/>
        </Dialog>

      }
    </>
  )
}

export const SubstituirCartao = props => {
  const [cartaoSelecionado, setCartaoSelecionado] = useState("");
  const [openDialogSubstituicao, setOpenDialogSubstituicao] = useState(false);
  const [novoCodigoCartao, setNovoCodigoCartao] = useState("");

  const abrirModalSubstituicao = (id) => {
    setCartaoSelecionado(props.cartoes.find(c => c.id === id));
    setOpenDialogSubstituicao(true);
  }

  const submitSubstituicaoCartao = (id) => {
    EscolaService.substituirCartao(props.processo, cartaoSelecionado.codigoInep === "" || cartaoSelecionado.codigoInep === undefined ? cartaoSelecionado.codigo.substr(2, 8) : cartaoSelecionado.codigoInep, cartaoSelecionado.id, {
      "idCartaoAtual": cartaoSelecionado.id,
      "codigoCartaoSubstituto": novoCodigoCartao
    }).then(resultado => {
      setOpenDialogSubstituicao(false);
    }).catch(resultado => {
      setOpenDialogSubstituicao(false);

      props.aoOcorrerErro();
    });
  }

  return (
    <>
      <ActionCellBody id={props.cartao.id}
                      action={{
                        name: () => "Substituir Cartão",
                        func: abrirModalSubstituicao,
                        icon: <Refresh/>,
                        disabled: (id) => {
                          const cartao = props.cartoes.find(c => c.id === id);
                          return cartao.substituido || cartao.status === "DESCARTADO";
                        },
                      }}
                      object={props.cartao}/>
      {openDialogSubstituicao &&
        <Dialog
          maxWidth={"lg"}
          fullWidth={true}
          closeDialog={() => setOpenDialogSubstituicao(false)}
          openDialog={openDialogSubstituicao}
          title={`Substituir Cartão ${cartaoSelecionado.codigo}`}
          actions={[]}
        >
          <TextField label="Informe o novo código" value={novoCodigoCartao}
                     onChange={(e) => setNovoCodigoCartao(e.target.value)}/>
          <ButtonSave onClick={submitSubstituicaoCartao}/>
        </Dialog>
      }
    </>
  )

}

